import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatsIncluded() {
  const inclusions = ['Más de 30 recetas de coberturas y glaseados', 'Recetas fáciles con ingredientes simples', 'Coberturas clásicas que siempre funcionan', 'Ideas para decorar y mejorar cualquier budín', 'Combinaciones que hacen que un budín simple se vea espectacular'];
  return <section className="py-20 bg-[#FFF8F0] text-[#3D2B1F] px-4" data-id="element-219">
      <div className="max-w-3xl mx-auto" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2rem] p-8 md:p-12 border border-[#C67B30]/20 shadow-xl" data-id="element-221">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-10 text-[#3D2B1F]" data-id="element-222">
            Dentro de este libro vas a descubrir:
          </h2>

          <ul className="space-y-6 mb-10" data-id="element-223">
            {inclusions.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#FFF8F0] p-4 rounded-2xl border border-[#3D2B1F]/5" data-id="element-224">
                <div className="bg-[#C67B30]/15 p-2 rounded-full shrink-0" data-id="element-225">
                  <CheckIcon className="w-6 h-6 text-[#C67B30]" strokeWidth={3} data-id="element-226" />
                </div>
                <span className="text-xl text-[#4A3728] font-medium pt-1" data-id="element-227">
                  {item}
                </span>
              </motion.li>)}
          </ul>

          <div className="text-center p-6 bg-[#C67B30]/10 rounded-2xl border border-[#C67B30]/20" data-id="element-228">
            <p className="text-xl font-bold text-[#C67B30]" data-id="element-229">
              Todo explicado paso a paso para que puedas aplicarlo
              inmediatamente en tu cocina.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}